import './project-preference.scss';

import { ThunkDispatch } from 'redux-thunk';

import * as Model from '../../../models';
import * as I18n from '../../../models/i18n';
import * as ModelUtil from '../../../models/util';
import * as ProjectActions from '../../../actions/project-actions';

import { cloneOptions, preferenceOptionsToPreference } from '../../oligo-config-preference/oligo-config-preference';
import { OligoConfigPreferenceChangeHandler, OligoConfigPreferenceOptions } from '../../oligo-config-preference/oligo-config-preference';

export const PROJECT_PREFERENCE_SHOW: string = 'project-preference-show';
export const PROJECT_PREFERENCE_NAME: string = 'projectPreference';

type ProjectPreferenceOptions = OligoConfigPreferenceOptions;

function preferenceTitle(headerTpl: string, project: Model.ProjectItem): string {
  return I18n.replacePlaceHolders(headerTpl, { [I18n.PlaceHolderKeys.PROJECT_NUMBER]: project ? `${project.index + 1}` : '' });
}

type I18nAware = {
  HEADER_TITLE_TPL: string;
  APPLY_PREFERENCE_LABEL: string;
};

export class ProjectPreferenceController implements ng.IComponentController, I18nAware, ProjectActions.ProjectUpdateSupport {

  public MODAL_ID: string = 'project-preference';

  public options: ProjectPreferenceOptions | null = {
    scale: {
      items: ModelUtil.defaultDropDownContent(),
    },
    purification: {
      items: ModelUtil.defaultDropDownContent(),
    },
    format: {
      items: ModelUtil.defaultDropDownContent(),
    },
  };
  public preference?: Model.ProjectPreference;
  public preferenceTitle?: string;

  public preferenceChangeHandler: OligoConfigPreferenceChangeHandler;
  public openedAtLeastOnce: boolean = false;
  public loading: boolean = false;
  public updateProject: ProjectActions.ProjectUpdate | null = null;
  public applyPreference: () => void;
  public HEADER_TITLE_TPL: string = 'Project {{PROJECT_NUMBER}} Preferences';
  public APPLY_PREFERENCE_LABEL: string = 'Apply to project';
  public project?: Model.ProjectItem;

  private jq?: Model.BootstrapJQ;

  constructor($scope: ng.IScope,
              $ngRedux: Model.INgRedux,
              projectActions: ProjectActions.ProjectActions) {
    const bindDispatchers = (dispatch: ThunkDispatch<Model.RootState, object, Model.ReduxAction<object>>) => {
      this.updateProject = (request: ProjectActions.ProjectUpdateFnRequest) => {
        return dispatch(projectActions.updateProject(request));
      };
    };
    const unsubscribeRedux = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);

    // commenting this as part of tslint issue fix
    // let project: Model.ProjectItem;
    let latestOptions: ProjectPreferenceOptions | undefined;
    const projectChangeListener = (event: ng.IAngularEvent, newProject: Model.ProjectItemOrNull) => {
      if (!newProject) {
        return;
      }
      const { preference } = newProject;
      this.loading = true;
      this.openedAtLeastOnce = true;
      this.preference = { ...preference };
      // commenting this as part of tslint issue fix
      // this.preferenceTitle = preferenceTitle(this.HEADER_TITLE_TPL, project);
      this.preferenceTitle = preferenceTitle(this.HEADER_TITLE_TPL, newProject);
    };

    const preferenceChangeHandler: OligoConfigPreferenceChangeHandler = {
      onOptionChangeStart: (): void => {
        this.loading = true;
      },
      onOptionChangeSuccess: (newOptions: OligoConfigPreferenceOptions): void => {
        const options: ProjectPreferenceOptions = { ...newOptions };
        this.options = options;
        latestOptions = cloneOptions(options);
        this.loading = false;
      },
      onOptionChangeFailed: (errorCause: object): void => {
        this.loading = false;
        if (latestOptions) {
          this.options = cloneOptions(latestOptions);
        }
        $scope.$emit(Model.ScopeEvents.ERROR, errorCause);
      },
    };

    const applyPreference = (): void => {
      if (!this.options || !this.updateProject) {
        return;
      }
      const preference: Model.ProjectPreference = preferenceOptionsToPreference(this.options);
      if (this.project) {
        const request: ProjectActions.ProjectUpdateFnRequest = { ...this.project, ...{ preference } };
        this.loading = true;
        this.updateProject(request).then(() => {
          this.getJQ().modal('hide');
        }, (errorCause: object) => {
          // delegate to global error handler
          $scope.$emit(Model.ScopeEvents.ERROR, errorCause);
        }).finally(() => this.loading = false);
     }
    };

    this.preferenceChangeHandler = preferenceChangeHandler;
    this.applyPreference = applyPreference;

    const unwatchProjectChange = $scope.$on(PROJECT_PREFERENCE_SHOW, projectChangeListener);

    $scope.$on('$destroy', () => {
      unsubscribeRedux();
      unwatchProjectChange();
    });
  }

  public $onDestroy(): void {
    this.options = null;
    this.updateProject = null;
  }

  private getJQ(): Model.BootstrapJQ {
    if (!this.jq) {
      this.jq = $(`#${this.MODAL_ID}`) as Model.BootstrapJQ;
    }
    return this.jq;
  }

  private mapStateToThis(state: Model.RootState): I18nAware {
    const { world } = state;
    const { vocabulary } = world;
    return {
      HEADER_TITLE_TPL: vocabulary[I18n.DictionaryKeys.PROJECT_PREFERENCE_POPOVER_TITLE] || this.HEADER_TITLE_TPL,
      APPLY_PREFERENCE_LABEL: vocabulary[I18n.DictionaryKeys.PROJECT_PREFERENCE_POPOVER_APPLY_BUTTON] || this.APPLY_PREFERENCE_LABEL,
    };
  }

}

export const ProjectPreference: ng.IComponentOptions = {
  template: (() => {
    const bsJQ: Model.BootstrapJQ = $.fn as Model.BootstrapJQ;
    if (!bsJQ.modal || !bsJQ.modal.Constructor) {
      return '';
    }
    const version: string = bsJQ.modal.Constructor.VERSION;
    if (version) {
      if (version.indexOf('4') === 0) {
        return require('./project-preference.tpl.bs4.html');
      }
    } else {
      const isBS2: boolean = bsJQ.modal.toString().indexOf('bs.modal') === -1;
      if (isBS2) {
        return require('./project-preference.tpl.html');
      }
    }
    return '';
  })(),
  controller: ProjectPreferenceController,
  controllerAs: 'projectPreference',
  bindings: {
    preferenceTitle: '@',
    openedAtLeastOnce: '<',
    preference: '=',
    project: '=',
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/project-detail/project-preference/project-preference.ts